import React, { useState, useRef, useEffect } from 'react';
import { Link as RouterLink, Link, useLocation, useNavigate } from 'react-router-dom';
import { format } from 'date-fns';
import { useAuth } from '../../context/AuthContext';
import './Header.css';
import { FaGlobe, FaUser, FaBars, FaChevronDown } from 'react-icons/fa';
import { MdDirectionsBoat } from 'react-icons/md';
import { GiHelicopter } from 'react-icons/gi';
import Calendar from '../Calendar/Calendar';
import logoImage from '../../assets/logo_image.png';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [selectedDate, setSelectedDate] = useState(null);
  const [showCalendar, setShowCalendar] = useState(false);
  const [isGuideDropdownOpen, setIsGuideDropdownOpen] = useState(false);
  const guideDropdownRef = useRef(null);
  const location = useLocation();
  const navigate = useNavigate();
  const { user, logout } = useAuth();
  const menuRef = useRef(null);
  const buttonRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        isMenuOpen &&
        menuRef.current &&
        !menuRef.current.contains(event.target) &&
        buttonRef.current &&
        !buttonRef.current.contains(event.target)
      ) {
        setIsMenuOpen(false);
      }
      if (
        isGuideDropdownOpen &&
        guideDropdownRef.current &&
        !guideDropdownRef.current.contains(event.target)
      ) {
        setIsGuideDropdownOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isMenuOpen, isGuideDropdownOpen]);

  const handleDateSelect = (date) => {
    setSelectedDate(date);
    setShowCalendar(false);
  };

  const handleLogout = async () => {
    try {
      await logout();
      setIsMenuOpen(false);
      navigate('/');
    } catch (error) {
      console.error('Logout error:', error);
    }
  };

  const handleMenuItemClick = () => {
    setIsMenuOpen(false);
  };

  const handleSearch = () => {
    // navigate('/search', {
    //   state: {
    //     selectedDate,
    //     location: location.pathname,
    //   },
    // });
    navigate('/explore-yachts');
  };

  const isYachtListPage = location.pathname === '/' || location.pathname === '/login' || location.pathname === '/signup';
  const headerClassName = `header ${isYachtListPage ? 'sticky' : ''}`;
  const isYachtOwner = user && user.userType === 'owner';

  const renderAuthenticatedMenuItems = () => {
    if (!user) return null;

    if (user.userType === 'owner') {
      return (
        <>
          <Link to="/dashboard" onClick={handleMenuItemClick}>Dashboard</Link>
          <Link to="/my-yachts" onClick={handleMenuItemClick}>My Yachts</Link>
          <Link to="/yacht-bookings" onClick={handleMenuItemClick}>Bookings</Link>
          <Link to="/yacht-add-ons" onClick={handleMenuItemClick}>Yacht Add-Ons</Link>
          <Link to="/yacht-pricing" onClick={handleMenuItemClick}>Yacht Pricing</Link>
          <Link to="/manage-unavailability" onClick={handleMenuItemClick}>Manage Unavailability</Link>
          <Link to="/contact" onClick={handleMenuItemClick}>Contact Us</Link>
          {/* add a horizontal line make the line black */}
          <hr />
          <Link to="/my-experiences" onClick={handleMenuItemClick}>My Experiences</Link>
          <Link to="/experience-options" onClick={handleMenuItemClick}>Experience Options</Link>
          <Link to="/experience-bookings" onClick={handleMenuItemClick}>Experience Bookings</Link>
          <button onClick={handleLogout} className="logout-button">Log out</button>
        </>
      );
    }

    return (
      <>
        <Link to="/profile" onClick={handleMenuItemClick}>Profile</Link>
        <Link to="/my-bookings" onClick={handleMenuItemClick}>My Bookings</Link>
        <Link to="/favorites" onClick={handleMenuItemClick}>Favorites</Link>
        <Link to="/contact" onClick={handleMenuItemClick}>Contact Us</Link>
        <button onClick={handleLogout} className="logout-button">Log out</button>
      </>
    );
  };

  return (
    <header className={headerClassName}>
      <div className="header-container">
        <Link to="/" className="logo">
          <img src={logoImage} alt="Bosphorus Yachts" className="logo-image" />
        </Link>

        <div className="nav-tabs">
          <Link 
            to="/explore-yachts" 
            className={`nav-tab ${location.pathname === '/explore-yachts' ? 'active' : ''}`}
          >
            <MdDirectionsBoat className="nav-tab-icon" />
            <span>Yachts</span>
          </Link>
          <Link 
            to="/experiences" 
            className={`nav-tab ${location.pathname === '/experiences' ? 'active' : ''}`}
          >
            <span className="new-badge">NEW</span>
            <GiHelicopter className="nav-tab-icon" />
            <span>Experiences</span>
          </Link>
        </div>

        {//isYachtListPage && (
          // <div className="search-section">
          //   <div className="search-bar">
          //     <input 
          //       type="text" 
          //       placeholder="Starting Location"
          //       className="location-input"
          //     />
          //     <div 
          //       className="date-input-container"
          //       onClick={() => setShowCalendar(true)}
          //     >
          //       <input 
          //         type="text" 
          //         readOnly
          //         value={selectedDate ? format(selectedDate, 'MMM dd, yyyy') : ''}
          //         className="date-input"
          //         placeholder="When"
          //       />
          //     </div>
          //     <input 
          //       type="number" 
          //       placeholder="Guests"
          //       min="1"
          //       className="guests-input"
          //     />
          //     <button className="search-button" onClick={handleSearch}>
          //       Search
          //     </button>
          //   </div>
          // </div>
        //)
        }

        <div className="nav-controls">
          {/* Guide Info Dropdown */}
          <div className="guide-dropdown-container" ref={guideDropdownRef}>
            <button 
              className="guide-dropdown-button"
              onClick={() => setIsGuideDropdownOpen(!isGuideDropdownOpen)}
            >
              Guides <FaChevronDown className={`dropdown-arrow ${isGuideDropdownOpen ? 'open' : ''}`} />
            </button>
            {isGuideDropdownOpen && (
              <div className="guide-dropdown-menu">
                <Link 
                  to="/hours-of-the-day" 
                  onClick={() => setIsGuideDropdownOpen(false)}
                >
                  Hours of the Day
                </Link>
                <Link 
                  to="/pier-guides" 
                  onClick={() => setIsGuideDropdownOpen(false)}
                >
                  Pier Guides
                </Link>
                <Link 
                  to="/blogs" 
                  onClick={() => setIsGuideDropdownOpen(false)}
                >
                  Blogs
                </Link>
              </div>
            )}
          </div>

          
          <button 
            ref={buttonRef}
            className="menu-button"
            aria-label="Open navigation menu"
            onClick={() => setIsMenuOpen(!isMenuOpen)}
          >
            <FaBars />
            {user && (
              <span className="user-name">
                {user.firstName}
              </span>
            )}
            {!user && <FaUser />}
          </button>
        </div>

        {isMenuOpen && (
          <div ref={menuRef} className="dropdown-menu">
            {user ? (
              renderAuthenticatedMenuItems()
            ) : (
              <>
                <Link to="/login" onClick={handleMenuItemClick}>Log in</Link>
                <Link to="/signup" onClick={handleMenuItemClick}>Sign up</Link>
                {
                //<Link to="/list-your-yacht">List your yacht</Link>
                }
                <Link to="/help" onClick={handleMenuItemClick}>Help</Link>
              </>
            )}
          </div>
        )}
      </div>

      {showCalendar && (
        <Calendar
          selectedDate={selectedDate}
          onDateSelect={handleDateSelect}
          onClose={() => setShowCalendar(false)}
        />
      )}
    </header>
  );
};

export default Header;
